import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../../context/page-context';
import type { TeamMemberApiResponse } from '../../../types';
import { useRemoveTeamMember } from '../../hooks/use-remove-team-member';

export function RemoveMemberModal({
  member,
  isOpen,
  closeModal,
}: {
  member: TeamMemberApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const { mutate: removeMember, isPending, reset } = useRemoveTeamMember();

  const handleClose = () => {
    if (isPending) {
      return;
    }
    reset();
    closeModal();
  };

  const handleSubmit = () => {
    if (!member) {
      return;
    }

    removeMember(member.id, {
      onSuccess: handleClose,
      onError: () => notificationHandler.error(),
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      primaryAction={{
        text: t('buttons:remove'),
        onClick: handleSubmit,
        danger: true,
        disabled: isPending,
        loading: isPending,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: handleClose,
        disabled: isPending,
      }}
    >
      <Modal.Header>
        {t('features:account.components.modals.remove_member_modal.header', {
          name: member?.name ?? '',
        })}
      </Modal.Header>
      <Modal.Body>
        <Text>
          {t('features:account.components.modals.remove_member_modal.body', {
            name: member?.name ?? '',
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
